/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_1_DescInputs */

const en_mk_sec_1_desc = /** @type {(inputs: Mk_Sec_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the CLI workflow, sync uploads the manifest and agent summaries. Review the contents before sending.`)
};

const id_mk_sec_1_desc = /** @type {(inputs: Mk_Sec_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pada alur CLI, sync mengunggah manifest dan ringkasan dari agent. Tinjau isinya sebelum mengirim.`)
};

/**
* | output |
* | --- |
* | "In the CLI workflow, sync uploads the manifest and agent summaries. Review the contents before sending." |
*
* @param {Mk_Sec_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_1_desc = /** @type {((inputs?: Mk_Sec_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_1_desc(inputs)
	return en_mk_sec_1_desc(inputs)
});